import ScientificAnalysisFilterPanelBoolean from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel-boolean/scientific-analysis-filter-panel-boolean'
import ScientificAnalysisFilterPanelFreetext from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel-freetext/scientific-analysis-filter-panel-freetext'
import ScientificAnalysisFilterPanelRange from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel-range/scientific-analysis-filter-panel-range'
import ScientificAnalysisFilterPanelSelectentity from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel-selectentity/scientific-analysis-filter-panel-selectentity'
import ScientificAnalysisFilterPanelSelectpatientidentifier from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel-selectpatientidentifier/scientific-analysis-filter-panel-selectpatientidentifier'
import { ScientificAnalysisComparisonType } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import ScientificAnalysisFilterPanelPatientage from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel-patientage/scientific-analysis-filter-panel-patientage'

// Set of interfaces to allow static method interfaces
export function ScientificAnalysisStaticImplements<T>() {
    return (_constructor: T) => { }
}

interface Type<T> {
    new(...args: any[]): T;
}

export interface ScientificAnalysisConditionComponent<T> extends Type<T> {
    COMPONENT_NAME: string
    canAccept(comparisonType: ScientificAnalysisComparisonType): boolean
}

export interface ScientificAnalysisConditionComponentFactory {
    getComponent(comparisonType: ScientificAnalysisComparisonType): string | null
}

class ScientificAnalysisConditionComponentFactoryReal implements ScientificAnalysisConditionComponentFactory {
    private getComponents(): ScientificAnalysisConditionComponent<any>[] {
        return [
            ScientificAnalysisFilterPanelFreetext,
            ScientificAnalysisFilterPanelBoolean,
            ScientificAnalysisFilterPanelRange,
            ScientificAnalysisFilterPanelSelectpatientidentifier,
            ScientificAnalysisFilterPanelSelectentity,
            ScientificAnalysisFilterPanelPatientage
        ]
    }

    getComponent(comparisonType: ScientificAnalysisComparisonType): string | null {
        const metainfo = ScientificAnalysisFilterPanelPatientage.PATIENT_AGE_METAINFO
        const found = this.getComponents().find(comp => comp.canAccept(comparisonType))
        return (found ? found.COMPONENT_NAME : null)
    }
}

export const scientificAnalysisConditionComponentFactory: ScientificAnalysisConditionComponentFactory = new ScientificAnalysisConditionComponentFactoryReal()
